import * as React from 'react';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import AppForm from '../form/appForm';
import { AppTextField } from '../form/appTextField';
import { email, required } from '../form/formValidations';

import styles from './loginForm.module.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class LoginForm extends React.Component {
  public render() {
    return (
      <AppForm
        form={FormId.LoginForm}
        submitText="Login"
        submitActionType={DataRequestActionTypes.LoginRequested}
        className={styles.loginForm}
      >
        <AppTextField name="email" label="Email" validate={[required, email]} />
        <AppTextField name="password" label="Password" type="password" validate={[required]} />
      </AppForm>
    );
  }
}
